<template>
  <div class="row">
    <div class="col-l-3 col-s-12 offset-top-1 pull-right">
      <!-- #171 -->
      <div v-if="productLogoResourcePath" class="s-center-l-right">
        <img :src="'delegates/product/content/' + productLogoResourcePath" :alt="productLogoAlt" class="product-image" />
      </div>
    </div>
    <div class="col-l-9 col-s-12">
      <p>
        <strong>
          <span v-html="productName"></span>
          <!-- #170 -->
        </strong>
      </p>
      <p v-html="productDescription"></p>
      <!-- #188 -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductChangeDescription',

  props: {
    product: {
      type: Object,
      required: true,
    },

    propertySuffix: {
      type: String,
      required: true,
    },
  },

  computed: {
    productName() {
      return this.product.texts.productName;
    },

    productDescription() {
      return this.product.texts[`productDescriptionChange${this.propertySuffix}`];
    },

    productLogoResourcePath() {
      return this.product.images[`productLogoChange${this.propertySuffix}ResourcePath`];
    },

    productLogoAlt() {
      return this.product.images[`productLogoChange${this.propertySuffix}Alt`];
    },
  },
};
</script>
